import { Component, ElementRef, OnDestroy, OnInit, Optional } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { TaskHandler } from '../../TaskHandler';
import {
  InboxRole,
  ProfileAssignmentDTO,
  ProfileTableRowModel,
  ReassignActionType,
  TaskAssignmentContextConfig,
  TaskAssignmentDTO
} from '../model/taskAssignment.model';
import * as lodash from 'lodash';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { FieldConfig } from '../../../api/contract-notice-dto';
import { ProcedureDTO, OrganizationalUnitDTO, InboxDTO, ProfileDTO } from '../../../api/plyca-dtos';
import { HeaderActionsService } from '../../../components/common/sub-header/header-actions.service';
import { FunctionDef } from '../../../components/forms/form.objects';
import { Configuration } from '../../../conf/app.constants';
import { UIService, generateRandomIdentifier } from '../../../ui.service';



@Component({
  templateUrl: 'taskAssignment.template.html',
  providers: [DialogService, UIService],
})
export class TaskAssignmentComponent extends TaskHandler implements OnInit, OnDestroy {

  public windowHash: string;

  public context: TaskAssignmentContextConfig;
  public assignment: TaskAssignmentDTO;
  private procedure: ProcedureDTO;
  /**
   * Objeto utilizado formelement del campo de busqueda de unidades organicas
   * ya que necesita una propiedad/json path sobre un objeto para hacer binding
   */
  public organizationalUnitModel: {
    organizationalUnit?: OrganizationalUnitDTO;
  }

  // variables de la tabla
  public profiles: ProfileTableRowModel[];
  public order: string;
  public colHeaders: string[];

  // check reasignar por perfiles
  public isVisibleReassignByProfiles: boolean;
  public reassignByProfiles = false;
  // variables de reasignacion desde protocolo
  public displayLoadProtocol = false;
  // tipo de reasignacionde desde protocolo
  public ReassignActionType = ReassignActionType;
  public reassignActionType: ReassignActionType;

  // variables de reasignacion
  public displaySaveOptions = false;
  public overrideAllWithProtocol = false;

  public displayDeleteHistory = false;


  public functions: Array<FunctionDef>;

  constructor(private headerActionsService: HeaderActionsService,
    @Optional() protected dialogRef: DynamicDialogRef,
    @Optional() protected dialogConfig: DynamicDialogConfig,
    private configuration: Configuration,
    private elem: ElementRef,
    private plycaErrorHandler: PlycaErrorHandler) {
    super();
    if (this.dialogConfig && this.dialogConfig.data) {
      this.windowHash = generateRandomIdentifier();
      this.procedure = this.dialogConfig.data.procedure;
      // if (!this.procedure) {
      //   console.error('No se ha pasado el parametro con el identificador del tramite');
      //   this.uiService.showMessage(this.translateService.instant('General.error'));
      //   this.dialogRef.close({ saved: false });
      // }
    }
    this.colHeaders = [
      'General.select',
      'Substitution.profile.name',
      'TaskAssignment.inbox.dispatcher',
      'TaskAssignment.inbox.signer'
    ];
    this.organizationalUnitModel = {};
    this.functions = [];
    this.functions.push({
      identifier: 'setSelectedInboxDescription',
      fn: this.setSelectedInboxDescription.bind(this)
    });
  }

  ngOnInit(): void {
    this.subscribe(this.loadAssignmentsTableObservable().pipe(
      tap(() => {
        this.initHeaderActions();
      })
    ));
  }

  ngOnDestroy(): void {
    this.dialogRef = null;
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  public saveOptions(): void {
    this.displaySaveOptions = false;
    if (!this.task && this.reassignActionType === ReassignActionType.ALL_PROCEDURE
      && this.context.deleteHistory && this.context.deleteHistory.value) {

      // solicitar borrar historial, no borrarlo o cancelar
      this.displayDeleteHistory = true;
    } else {
      // solicitar configuración
      this.confirmationService.confirm({
        message: this.translateService.instant('TaskAssignment.confirmation.msg'),
        accept: () => this.save()
      });
    }
    /*
        this.confirmationService.confirm({
          message: this.translateService.instant('TaskAssignment.confirmation.msg'),
          accept: () => {
            if (!this.task && this.reassignActionType === ReassignActionType.ALL_PROCEDURE
              && this.context.deleteHistory && this.context.deleteHistory.value) {
              // preguntar si borrar historial
              this.confirmationServiceDeleteHistory.confirm({
                message: this.translateService.instant('TaskAssignment.confirmation.delete'),
                accept: () => {
                  // guardar y borrar historial
                  this.save(true);
                },
                reject: () => {
                  // guardar sin borrar historial
                  this.save();
                }
              });
            } else {
              this.save();
            }
          }
        });
        */
  }

  public getFieldConfigDispatcher(data: ProfileTableRowModel): FieldConfig {
    let fieldConfig = this.getInboxSearchFieldConfig(data);
    this.setFieldConfigId(fieldConfig, data.profile, 'dispatcher');
    fieldConfig.editable = this.isAssignmentEditable(data.dispatcher);
    return fieldConfig;
  }

  public getFieldConfigSigner(data: ProfileTableRowModel): FieldConfig {
    let fieldConfig = this.getInboxSearchFieldConfig(data);
    this.setFieldConfigId(fieldConfig, data.profile, 'signer');
    fieldConfig.editable = this.isAssignmentEditable(data.signer);
    return fieldConfig;
  }

  public getFieldConfigUO(): FieldConfig {
    let fieldConfig = new FieldConfig();
    fieldConfig.jsonField = 'organizationalUnit';
    fieldConfig.type = 'UOSEARCH';
    fieldConfig.descriptionKey = 'ProcurementProject.organizationalUni';
    fieldConfig.id = '_organizationalUnit';
    fieldConfig.fieldStyle = 'm-0 p-0 col-6';
    return fieldConfig;
  }

  public assignmentChanged(assignment: ProfileAssignmentDTO, signer = false,
    event: { oldValue: InboxDTO, newValue: InboxDTO }): void {

    // tslint:disable-next-line:triple-equals
    let changed = ((!event.oldValue || !event.oldValue.identifier) && event.newValue && event.newValue.identifier != undefined)
      || (event.oldValue && event.oldValue.identifier && (!event.newValue || !event.newValue.identifier))
      || (event.oldValue.identifier !== event.newValue.identifier);
    if (changed && assignment.inbox && !signer) {
      this.confirmationService.confirm({
        message: this.translateService.instant('TaskAssignment.questions.definitive'),
        acceptLabel: this.translateService.instant('General.yes'),
        rejectLabel: this.translateService.instant('General.no'),
        accept: () => {
          assignment.inbox.definitive = true;
        },
        reject: () => {
          assignment.inbox.definitive = false;
        }
      });
    }
  }

  public loadProtocol(override: boolean): void {
    let url = this.configuration.TASKASSIGNMENT_URL.replace('{dossierId}', this.getDossierId());
    let params = {
      taskId: (this.task) ? this.task.identifier : '',
      organizationalUnitIdentifier: this.organizationalUnitModel.organizationalUnit.identifier

    };
    this.waitService.startWaiting();
    this.subscribe(this.plycaService.get<TaskAssignmentDTO>(url, 'loadprotocol', params),
      (assignments: TaskAssignmentDTO) => {
        this.profiles.forEach((tableRow: ProfileTableRowModel) => {
          if (this.isAssignmentEditable(tableRow.dispatcher) &&
            (override ||
              (!tableRow.dispatcher.inbox || !tableRow.dispatcher.inbox.identifier))
          ) {
            // tslint:disable-next-line: triple-equals
            let manageDispatcher = this.context && this.context.manageDispatcher && this.context.manageDispatcher.value == true;
            let dispatcherProfile = this.getProfileAssignment(assignments,
              tableRow.profile.identifier,
              false);
            if (!manageDispatcher || !dispatcherProfile || !dispatcherProfile.inbox || !dispatcherProfile.inbox.identifier) {
              // se pone el valor del buzon firmante si se la propiedad manageDispatcher no es 'true',
              // o el protocolo no devuelve datos para el tramitador
              dispatcherProfile = this.getProfileAssignment(assignments,
                tableRow.profile.identifier,
                true);
            }
            if (dispatcherProfile && dispatcherProfile.inbox && dispatcherProfile.inbox.identifier) {
              this.addProfileAssignmentToModel(dispatcherProfile, tableRow, InboxRole.DISPATCHER);
            }
          }
          if (this.isAssignmentEditable(tableRow.signer) &&
            (override ||
              (!tableRow.signer.inbox || !tableRow.signer.inbox.identifier))
          ) {
            let signerProfile = this.getProfileAssignment(assignments, tableRow.profile.identifier, true);
            if (signerProfile && signerProfile.inbox && signerProfile.inbox.identifier) {
              this.addProfileAssignmentToModel(signerProfile, tableRow, InboxRole.SIGNER);
            }
          }
        })
      },
      (error: any) => this.plycaErrorHandler.showServerError(error),
      () => {
        this.waitService.cancelWaiting();
        this.closeProtocolWindow();
      });
  }

  public closeProtocolWindow(): void {
    this.displayLoadProtocol = false;
  }

  public setSelectedInboxDescription(formELementModel: any, {
    oldValue: oldValue,
    newValue: newValue
  }) {
    this.patchInboxDescription(newValue);
  }

  public save(deleteHistory = false): void {
    this.waitService.startWaiting();
    this.displayDeleteHistory = false;
    if (this.task) {
      // *********   Establecer opción reasignación marcada bien por: *******************************************************************
      //    - Selección del usuario en caso de ser visible el panel de opciones
      //    - Valor por defecto que se  carga en función de la variable de contexto, this.context.manageCurrentProcedure, proporcionada
      //      por el servicio y cargada en el método loadAssignmentTable de esta clase.
      this.assignment.reassignActionType = this.reassignActionType;
      // ********************************************************************************************************************************

      // asociar a tarea cambios sobre el clonado del work hecho en el interface
      this.task.work.taskAssignment = this.assignment;
      let modifiedAssignments = [] as ProfileAssignmentDTO[];
      // coger solo perfiles editables
      this.profiles.forEach((profile: ProfileTableRowModel) => {
        this.addIfAssignmentEditable(profile, modifiedAssignments);
      });
      this.assignment.listProfileAssignments = modifiedAssignments;
      // mantener / despachar
      this.processTask();
    } else {
      let modifiedAssignments = [] as ProfileAssignmentDTO[];
      if (this.reassignByProfiles) {
        // coger solo perfiles checkeados
        this.profiles.forEach((profile: ProfileTableRowModel) => {
          this.addIfProfileChecked(profile, modifiedAssignments);
        });
      } else {
        // coger solo perfiles modificados
        this.profiles.forEach((profile: ProfileTableRowModel) => {
          this.addIfAssignmentEditable(profile, modifiedAssignments);
        });
      }
      let updatedAssignments = {} as TaskAssignmentDTO;
      updatedAssignments.organizationalUnit = this.organizationalUnitModel.organizationalUnit;
      updatedAssignments.deleteHistory = deleteHistory;
      updatedAssignments.procedureSelected = this.procedure;
      updatedAssignments.reassignActionType = this.reassignActionType;
      updatedAssignments.listProfileAssignments = modifiedAssignments;
      updatedAssignments.identifier = this.assignment.identifier;
      this.saveInternal(updatedAssignments);
    }
  }

  private saveInternal(updatedAssignments: TaskAssignmentDTO): void {
    let url = this.configuration.TASKASSIGNMENT_URL.replace('{dossierId}', this.getDossierId()) + 'updateTaskAssignment';
    this.subscribe(this.plycaService.update<TaskAssignmentDTO>(url, updatedAssignments),
      (result: any) => {
        console.log('Reasignacion realizada');
        this.uiService.showMessage(this.translateService.instant('TaskAssignment.successMsg'),
          this.translateService.instant('General.info'));
        // this.dialogRef.close({ saved: true });
        this.dialogRef.close();
      },
      (error: any) => {
        this.errorHandler.showServerError(error);
      }
    );
  }

  /**
   *
   * @param assignments
   * @param arg1
   */
  private getProfileAssignment(assignments: TaskAssignmentDTO, profileId: string, signer: boolean): ProfileAssignmentDTO {
    let findedProfile: ProfileAssignmentDTO;
    if (assignments && assignments.listProfileAssignments) {
      findedProfile = assignments.listProfileAssignments.find((profileAssignment: ProfileAssignmentDTO) =>
        profileAssignment.profile.identifier === profileId
        && (
          (signer && profileAssignment.inboxRole === InboxRole.SIGNER)
          ||
          (!signer && profileAssignment.inboxRole === InboxRole.DISPATCHER)
        )
      );
    }
    return findedProfile;
  }

  private loadAssignmentsTable() {
    this.subscribe(this.loadAssignmentsTableObservable());
  }

  private loadAssignmentsTableObservable(): Observable<any> {
    let assignmentObs: Observable<TaskAssignmentDTO>;
    if (this.task) {
      // acceso tarea
      assignmentObs = of(lodash.cloneDeep(this.task.work.taskAssignment));
      this.context = this.task.work.context.configurations;
      this.procedure = this.task.procedure;
    } else if (this.procedure) {
      // apertura desde  gestion de tramites
      const params = {
        procedureId: this.procedure.identifier
      };
      let url = this.configuration.LOAD_TASKASSIGNMENT_URL.replace('{dossierId}', this.getDossierId());
      this.waitService.startWaiting();
      assignmentObs = this.plycaService.get<TaskAssignmentDTO>(url,
        'CARGA_VARIABLES',
        params);
    } else {
      // apertura desde  gestion de tramites
      // const params = {
      //   dossierId: this.getDossierId()
      // };
      let url = this.configuration.LOAD_TASKASSIGNMENT_URL.replace('{dossierId}', this.getDossierId());
      this.waitService.startWaiting();
      assignmentObs = this.plycaService.get<TaskAssignmentDTO>(url,
        'CARGA_USUEXP');
    }
    return assignmentObs.pipe(
      tap((assignments: TaskAssignmentDTO) => this.loadAssignmentTable(assignments)),
      catchError((error: any) => {
        this.profiles = [];
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      }),
      finalize(() => this.waitService.cancelWaiting())
    );
  }

  public getDossierId(): string {
    // 1 apertura tarea
    let dossierId = (this.task) ? this.task.division.project.identifier : '';

    // 2 apertura desde tramites
    if (!dossierId) {
      dossierId = (this.procedure) ? this.procedure.division.project.identifier : '';
    }

    // 3 apertura en modal (reco)
    if (!dossierId && this.dialogConfig.data.project.division) {
      dossierId = this.dialogConfig.data.project.division.project.identifier;
    }
    // 4 apertura en modal (contratacion)
    if (!dossierId) {
      dossierId = this.dialogConfig.data.project.identifier;
    }

    return dossierId;
  }

  private loadAssignmentTable(assignments: TaskAssignmentDTO, initLoad = true) {
    this.assignment = assignments;
    if (initLoad) {
      this.context = this.assignment.context.configurations;
      this.organizationalUnitModel.organizationalUnit = this.assignment.organizationalUnit;
      this.organizationalUnitModel.organizationalUnit['__description'] = (this.assignment.organizationalUnit) ?
        this.assignment.organizationalUnit.name
        :
        undefined
    }
    // valor por defecto de las opciones de guardado
    // tslint:disable-next-line:triple-equals
    if (this.context && this.context.manageCurrentProcedure && this.context.manageCurrentProcedure.value == true) {
      this.reassignActionType = ReassignActionType.NEW_AND_SELECTED_PROCEDURE;
    } else {
      // Cargar por defecto todos
      this.reassignActionType = ReassignActionType.ALL_PROCEDURE;
    }
    // reasignacion por perfiles
    this.isVisibleReassignByProfiles = !this.task
      && (this.context && this.context.isVisibleReassignByProfiles
        // tslint:disable-next-line:triple-equals
        && this.context.isVisibleReassignByProfiles.value == true);
    this.profiles = this.assignmentProfilesToTableModel(this.assignment.listProfileAssignments);
  }

  private addIfProfileChecked(profile: ProfileTableRowModel, list: ProfileAssignmentDTO[]): void {
    if (profile && profile.checked) {
      if (profile.signer && this.isAssignmentEditable(profile.signer)) {
        list.push(profile.signer);
      }
      if (profile.dispatcher && this.isAssignmentEditable(profile.dispatcher)) {
        list.push(profile.dispatcher);
      }
    }
  }


  private setFieldConfigId(fieldConfig: FieldConfig, profile: ProfileDTO, assignemtType: string) {
    fieldConfig.id = profile.identifier + '.' + assignemtType + '.inbox';
  }

  private addIfAssignmentEditable(profile: ProfileTableRowModel, list: ProfileAssignmentDTO[]): void {
    if (profile) {
      if (this.isAssignmentEditable(profile.signer)) {
        list.push(profile.signer);
      }
      if (this.isAssignmentEditable(profile.dispatcher)) {
        list.push(profile.dispatcher);
      }
    }
  }

  private isAssignmentEditable(assignment: ProfileAssignmentDTO): boolean {
    return assignment && !assignment.locked && assignment.assigned;
  }

  private assignmentProfilesToTableModel(listProfileAssignments: ProfileAssignmentDTO[]): ProfileTableRowModel[] {
    let profilesMap = new Map<string, ProfileTableRowModel>();
    if (listProfileAssignments) {
      listProfileAssignments.forEach((profileAssignment: ProfileAssignmentDTO) => {
        const assignmentProfile = profileAssignment.profile.identifier;
        let rowModel = profilesMap.get(assignmentProfile);
        if (!rowModel) {
          rowModel = new ProfileTableRowModel();
          profilesMap.set(assignmentProfile, rowModel);
        }
        this.addProfileAssignmentToModel(profileAssignment, rowModel);
      });
    }
    let model = [];
    profilesMap.forEach((value: ProfileTableRowModel) => model.push(value));
    return model;
  }

  private addProfileAssignmentToModel(profileAssignment: ProfileAssignmentDTO, rowModel: ProfileTableRowModel, role?: InboxRole) {
    if (!profileAssignment.inbox) {
      // si no tiene buzon asociado se crea uno vacio para que el binding pueda asociar uno nuevo
      // a partir del buscador
      profileAssignment.inbox = {} as InboxDTO;
    }
    this.patchInboxDescription(profileAssignment.inbox);
    let roleToAdd = role || profileAssignment.inboxRole;
    if (roleToAdd === InboxRole.DISPATCHER) {
      rowModel.dispatcher = profileAssignment;
    } else {
      rowModel.signer = profileAssignment;
    }
    rowModel.profile = profileAssignment.profile;
  }

  private patchInboxDescription(inbox: InboxDTO): void {
    if (inbox && inbox.identifier) {
      inbox['__description'] = '[' + inbox.identifier + '] ' + inbox.name;
    }
  }

  private getInboxSearchFieldConfig(data: ProfileTableRowModel): FieldConfig {
    let fieldConfig = new FieldConfig();
    fieldConfig.type = 'SEARCH';
    fieldConfig.description = '';
    fieldConfig.idBuscador = 'INBOX';
    fieldConfig.jsonField = 'inbox';
    // pasar los valores de los parametros como cadenas, porque se evaluan luego como expresion JS
    fieldConfig.parameters = [
      {
        'identifier': 'BUZON.USUARIOSNOBLOQUEADOS',
        'value': 'true'
      },
      {
        'identifier': 'PERFILBUZON.APLICACION',
        'value': this.getApplication()
      },
      {
        'identifier': 'PERFILBUZON.PERID',
        'value': '"' + data.profile.identifier + '"'
      },
      {
        'identifier': 'ORGANISMO.RUTA',
        'value': this.organizationalUnitModel.organizationalUnit
      }

    ];
    fieldConfig.autoSearch = true;
    fieldConfig.fieldStyle = 'm-0 p-0 col-10';
    fieldConfig.onChangeFunction = 'setSelectedInboxDescription';
    return fieldConfig;
  }

  private getApplication() {
    if (this.task) {
      return '"' + this.task.division.documentClass.application + '"';
    } else if (this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.project && this.dialogConfig.data.project.division
      && this.dialogConfig.data.project.division.documentClass
      && this.dialogConfig.data.project.division.documentClass.application) {
      return '"' + this.dialogConfig.data.project.division.documentClass.application + '"';
    } else {
      return '"CONTRATACION"';
    }
  }


  private initHeaderActions(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.task) {
      const infoVisible = false;
      const isModal = true;
      const showProjectInModal = false;
      this.headerActionsService.setProject(this.elem, this.getDossierId(), infoVisible, isModal, showProjectInModal);
    }
    if (this.context && this.context.isVisibleButtonReassign && this.context.isVisibleButtonReassign.value) {
      // Reasignar protocolo
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'TaskAssignment.reassign',
          'fas fa-briefcase',
          'btn-outline-secondary',
          true,
          this.windowHash
        ),
        () => {
          this.displayLoadProtocol = true;
        }
      );
    }
    // deshacer cambios
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.undo',
        'fas fa-redo',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => this.undo()
    );
    // guardar cambios
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.save',
        'fas fa-save',
        'btn-primary',
        true,
        this.windowHash
      ),
      () => {
        if (this.canShowSaveOptions()) {
          if (this.isVisiblePanelOptions()) {
            this.displaySaveOptions = true;
          } else {
            this.saveOptions();
          }
        }
      }
    );
    this.headerActionsService.addWindowDivider(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.cancel',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      success => {
        if (this.task) {
          this.salir();
        } else {
          this.dialogRef.close({ saved: false });
        }
      });
  }

  private isVisiblePanelOptions(): boolean {
    return this.context && this.context.isVisiblePanelActions && this.context.isVisiblePanelActions.value;
  }

  private undo(): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('TaskAssignment.undoMsg'),
      acceptLabel: this.translateService.instant('General.yes'),
      rejectLabel: this.translateService.instant('General.no'),
      accept: () => {
        this.loadAssignmentsTable();
      }
    });
  }

  /**
   * Validaciones previas a mostrar ventana de opciones para guardar
   */
  private canShowSaveOptions(): boolean {
    let showSaveOptions = true;
    if (this.reassignByProfiles) {
      let selectedProfiles = this.profiles.find((profile: ProfileTableRowModel) => profile && profile.checked);
      if (!selectedProfiles) {
        showSaveOptions = false;
        this.uiService.showMessage(this.translateService.instant('TaskAssignment.confirmation.chk'));
      }
    }
    return showSaveOptions;
  }
}
